'use client'
import { SelectInput } from '@payloadcms/ui/fields/Select'
import { useAuth, useField, useLocale, useTranslation } from '@payloadcms/ui'
import * as React from 'react'
import './index.scss'
const roleOptions = [
  {
    value: 'Agency Owner',
    label: {
      en: 'Agency Owner',
      fr: 'Propriétaire d’agence',
      ar: 'مالك الوكالة',
    },
  },
  {
    value: 'Agent',
    label: { 
      en: 'Agent', 
      fr: 'Agent', 
      ar: 'وكيل' 
  },
  },
  {
    value: 'Website Admin',
    label: { 
      en: 'Website Admin', 
      fr: 'Administrateur du site', 
      ar: 'مسؤول الموقع' 
    },
  },
  {
    value: 'Super Admin',
    label: { en: 
      'Super Admin', 
      fr: 'Super Administrateur', 
      ar: 'المسؤول الأعلى' 
    },
  },
]

// Define which roles can select which other roles
const rolePermissions = {
  'Super Admin': ['Agency Owner', 'Agent', 'Website Admin', 'Super Admin'],
  'Website Admin': ['Website Admin'],
  'Agency Owner': ['Agency Owner', 'Agent'],
  Agent: [],
}
export const CustomSelect: React.FC<{ path: string; label?: string }> = ({ path, label }) => {
  const { user } = useAuth()
  const { value, setValue } = useField<string>({ path })
  const locale = useLocale()
  const { i18n, t } = useTranslation()
  
  const allowedRoles = user?.role ? rolePermissions[user.role] || [] : []
  const language = i18n?.language || 'en'

  const localizedOptions = (user?.role
    ? roleOptions.filter((option) => allowedRoles.includes(option.value))
    : roleOptions
  ).map((option) => ({
    value: option.value,
    label: option.label[language] || option.label.en, // fallback to English
  }))

  const labelText = label?.[language] || label?.en || 'Role'

  return (
    <div className="margin">
      <label className="field-label">{labelText}</label>
      <SelectInput
        path={path}
        name={path}
        options={localizedOptions}
        value={value}
        onChange={(e) => {
          setValue(e.value)
        }}
      />
    </div>
  )
}
